import Vue from "vue";
import VueRouter from "vue-router";

import routes from './route'

Vue.use(VueRouter);

//解决同路由跳转报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
};

Vue.config.productionTip = false;

const router = new VueRouter({
    mode:"history",
    base: process.env.NODE_ENV === 'development'
        ? '/'
        : '/wangting/',//路径
    routes
});


export default router;
